import React, { useEffect, useState } from 'react'
import { Breadcrumb } from '../../common/atoms'
import { STEPATHON_LEADERBOARD as headers } from '../../../constants/tableHeaders'
import { Table } from '../../common/molecules'
import TeamListPageSchema from '../../../schemas/table/TeamListPageSchema'
import { useHistory, useLocation } from 'react-router-dom'
import { StepathonApi } from '../../../services'
import { handleAppError } from '../../handlers'
import { dsButtonPrimary, joinButtonClasses } from '../../../utils/buttonStyles'

const TeamListPage = () => {
  let location = useLocation()
  let history = useHistory()
  let [state , setState] = useState({
    locationData : {},
    openModal : false,
    expandArrow : null,
    loading : true,
    memberLoading : false,
    TeamData : [],
    TeamMemberData : [],
    reUploadButton : '',
    id:''
  })
  const setSubState = (newState) => {
    setState(prevState => { return {...prevState, ...newState} })
  }
  let fetchTeamList = (data) =>{
    let id = data?.id
    StepathonApi.fetchTeamListPage(
       { id :  id},
       (resp) => {
        let TeamListData = resp.data.teams
        setSubState({TeamData : TeamListData, reUploadButton : data.tag, loading : false})
       },
       (err) => {
        setSubState({loading : false}) 
        handleAppError(err);
       }
     );
   } 

   let fetchTeamMemberList = ( team_id, term = '') =>{
    let stepathon_id = state.locationData.id
    StepathonApi.fetchTeamListMembersPage(
      {id: stepathon_id, team_id : team_id, term : term},
      (resp) => {
        let TeamMemberListData = resp.data.members
        setSubState({TeamMemberData : TeamMemberListData, memberLoading : false})
      },
      (err) => {
        setSubState({memberLoading : false}) 
        handleAppError(err);
      }
    );
  }

  useEffect(()=>{
    setSubState({locationData:  location.state})
    fetchTeamList(location.state)
   },[location])

   let openIndividualData = (e, team_id) => {
    if(state.expandArrow !== team_id){
     setSubState({expandArrow : team_id, memberLoading: true})
     fetchTeamMemberList(team_id)
    }
    else{
     setSubState({expandArrow : null})
    }
  }

  let onSearchHandler = (value, key) =>{
    if (key === 'team'){
      let team_id = state.expandArrow
      fetchTeamMemberList(team_id , value)
    }
  }



  const navigateToUploadTeams =() =>{
      history.push({pathname : '/stepathon/team-upload', state : { stepathon_id : state.locationData.id, text: 're-upload'}})
  }


  return (
    <React.Fragment>
      <div className='flex flex-row justify-between'>
        <div>
          <Breadcrumb
            list={[
              { text: 'Engagement', link: '/stepathon' },
              { text: 'Stepathon', link: '/stepathon' },
              { text: 'View Teams', link: '#' }
            ]}
            classes='mb-1'
          />
          <p className='font-fig-extrabold text-3xl font-medium leading-tight tracking-tight text-gray-900 sm:text-4xl mb-0'>Teams</p>
        </div>
        { state.reUploadButton === 'Yet to Start' &&
          <button
            type='button'
            onClick={navigateToUploadTeams}
            style={{height: '44px', width: '178px'}}
            className={joinButtonClasses(dsButtonPrimary, 'h-11 px-6')}
          >
            Re-upload teams
          </button>
        }
      </div> 
      <Table
        headers={headers.create_teams}
        loading={state.loading}
        data={state.TeamData}
        name='table'
        openIndividualData={openIndividualData}
        IndividualData={state.TeamMemberData || []}
        headerClasses='pl-4 py-4'
        tableClasses='alternate_gray200_color'
        classes='rounded-md mt-6 mb-16 overflow-y-auto '
        tableschema={TeamListPageSchema}
        tableHeaderClasses='sticky top-0 z-10'
        arrowChange={state.expandArrow}
        onSearchHandler={onSearchHandler}
        memberLoading={state.memberLoading}
      />
    </React.Fragment>
  )
}

export default TeamListPage
